import { initSwiper } from '../../components/swiper';
import initAtcPopup from '../../components/atc-popup';
import initProductCardSwatches from '../../components/product-card-swatches';

const RECENT_VIEWED_LIMIT_DEFAULT = 8;

async function fetchProductCard(productHandle) {
  const response = await fetch(`/products/${productHandle}?section_id=recently-viewed-card`);
  if (!response.ok) return '';

  const html = await response.text();
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const card = doc.querySelector('[data-product-card]');
  return card ? card.outerHTML : '';
}

async function renderRecentlyViewed() {
  const recentlyViewedProductsEL = document.querySelector('[data-recently-viewed]');
  if (!recentlyViewedProductsEL) return;

  const currentHandle = recentlyViewedProductsEL.dataset.currentHandle;
  const productList = (JSON.parse(localStorage.getItem('recentlyViewed')) || []).filter(
    (productHandle) => productHandle !== currentHandle
  );
  const listContainer = document.querySelector('[data-recently-viewed-list]');
  if (!listContainer) return;

  if (!productList.length) return;

  for (const productHandle of productList) {
    const cardHtml = await fetchProductCard(productHandle);
    listContainer.insertAdjacentHTML('beforeend', `<li class="swiper-slide flex! h-auto!">${cardHtml}</li>`);
  }

  // These cards are injected after page load, so they missed the global
  // swatch binding - already-bound cards are skipped, so this only binds new ones.
  initProductCardSwatches();

  const navEl = recentlyViewedProductsEL.querySelector('[data-recently-viewed-nav]');
  if (navEl) navEl.hidden = false;

  const sliderEl = recentlyViewedProductsEL.querySelector('[data-swiper-recently-viewed]');
  if (!sliderEl) return;
  initSwiper(sliderEl);

  initAtcPopup();
}

const initRecentlyViewedProducts = () => {
  const recentlyViewedProductsEL = document.querySelector('[data-recently-viewed]');
  const recentlyViewedLimit = Number(recentlyViewedProductsEL?.dataset.recentlyViewedNum) || RECENT_VIEWED_LIMIT_DEFAULT;
  const productHandle = window.location.pathname.split('/').pop();
  const recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];

  if (!recentlyViewed.includes(productHandle)) {
    recentlyViewed.push(productHandle);
  }

  if (recentlyViewed.length > recentlyViewedLimit) {
    recentlyViewed.shift();
  }

  localStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));

  renderRecentlyViewed();
};

export default initRecentlyViewedProducts;